module.exports = __webpack_public_path__ + "static/media/logo-outline.d77392f4.png";